import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-unauthorised',
  templateUrl: './unauthorised.component.html',
  styleUrl: './unauthorised.component.scss',
})
export class UnauthorisedComponent {}
